import { INITIALIZE_ASSIGN_USER_FORM } from '../actionTypes';
import { installerProfileActions } from '../reducer';

export default (values) =>
    installerProfileActions[INITIALIZE_ASSIGN_USER_FORM](values);
